import axios from 'axios'
// import store from '@/store'
import router from '@/router'
// import server from '../server.config'
import utils from './utils'
// API
let WGY_API = process.env.API_1
// web
let WGY_WEB = process.env.API_2

function createFormData (data) {
  let formData = new FormData()
  for (let key in data) {
    formData.append(key, data[key])
  }
  return formData
}

const fetch = options => {
  let token = window.localStorage.getItem('token') || ''
  let opts = Object.assign({
    t: '',
    baseURL: options.host, // server[process.env.NODE_ENV],
    method: 'POST',
    headers: {
      Authorization: token,
      Version: '1.9.4'
    }
  }, options)
  // if (opts.url) {
  // let timeStr = `t=${localStorage.token}`
  // opts.url += /\?/.test(opts.url) ? '&' + timeStr : '?' + timeStr
  // }
  if (opts.method.toUpperCase() === 'POST') {
    opts.data = opts.params
    opts.params = {}
  }
  if (opts.form) {
    opts.data = createFormData(opts.data)
    opts.params = {}
  }
  opts.url += '?t=' + token

  return new Promise((resolve, reject) => {
    // store.commit('SHOW_LOADING', true)
    axios(opts).then(res => {
      // store.commit('SHOW_LOADING', false)
      if (res.status === 200) {
        if (res.data.ec === 200 || res.data.code === 1) {
          resolve(res.data.data)
        } else if (res.data.ec === 400) {
          reject(res.data.em)
        } else if (res.data.code === 0) {
          reject(res.data.msg)
        } else if (res.data.ec === 400000 || res.data.ec === 400001) {
          let callback = encodeURIComponent(window.location.href)
          // 登录失效，未授权
          let browserType = utils.getBrowserType()
          if (browserType === 'AliApp' || browserType === 'wxwork') {
            window.location.href = WGY_WEB + '/auth/code?callback=' + callback
          } else if (browserType === 'wx') {
            window.location.href = WGY_API + '/wechat/auth?callback=' + callback
          } else {
            res.data.em = '您还未登录，暂无权限查看'
            router.replace('/Error?info=' + encodeURIComponent(encodeURIComponent(res.data.em)))
          }
        } else {
          reject(res.data)
        }
      } else {
        reject(res)
      }
    }).catch(err => {
      // store.commit('SHOW_LOADING', false)
      reject(err)
    })
  })
}

export default fetch



// WEBPACK FOOTER //
// ./src/lib/fetch.js